// Display-only cleanup. Always retain the complete email for expansion.
export const emailReplyPreview = value => {
  const original = String(value || "");
  const lines = original.replace(/\r\n?/g, "\n").split("\n");
  for (let index = 1; index < lines.length; index++) {
    if (!/^\s*On\s/i.test(lines[index])) continue;
    for (let end = index; end < Math.min(index + 6, lines.length); end++) {
      const header = lines.slice(index, end + 1).join(" ").trim();
      if (!/\bwrote:\s*$/i.test(header)) continue;
      const quoted = lines.slice(end + 1).filter(line => line.trim());
      // Keep inline/bottom-posted answers visible rather than assuming they are history.
      if (!quoted.length || !quoted.every(line => /^\s*>/.test(line))) break;
      const reply = lines.slice(0, index).join("\n").trim();
      if (reply) return { text: reply, hasQuotedHistory: true };
      break;
    }
  }
  return { text: original, hasQuotedHistory: false };
};
